import React, {Component} from 'react';

import translations from './Translations'

class DashBoard extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        return (
            <div>
                <section className="content-header">
                    <h1>
                        {translations.dash[this.props.language]}
                        <small>Control panel</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"><i className="fa fa-dashboard" /> {translations.home[this.props.language]}</a></li>
                        <li className="active">{translations.dash[this.props.language]}</li>
                    </ol>
                </section>

                <section className="content">
                    {/* Small boxes (Stat box) */}
                    <div className="row">
                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-aqua">
                                <div className="inner">
                                    <h3>{this.props.lifetimeEarnings}</h3>
                                    <p>{translations.life_earnings[this.props.language]}</p>
                                </div>
                                <div className="icon">
                                    <i className="ion ion-bag" />
                                </div>
                                <a href="#" className="small-box-footer">More info <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>

                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3>{this.props.commission}</h3>
                                    <p>{translations.commissions_pay[this.props.language]}</p>
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">More info <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>



                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3>{this.props.jobsCompleted}</h3>
                                    <p>{translations.jobs_completed[this.props.language]}</p>
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">More info <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>


                        <div className="col-lg-3 col-xs-6">
                            {/* small box */}
                            <div className="small-box bg-yellow">
                                <div className="inner">
                                    <h3 style={{"text-transform": "capitalize"}}>{
                                        this.props.active==="Enabled"? translations.enabled[this.props.language]: translations.disabled[this.props.language]

                                    }</h3>
                                    <p>{translations.your_status[this.props.language]}</p>
                                </div>
                                <div className="icon">
                                    <i className="ion ion-person-add" />
                                </div>
                                <a href="#" className="small-box-footer">More info <i className="fa fa-arrow-circle-right" /></a>
                            </div>
                        </div>

                        {/*<h2 className={"text-center"}>Account Details for Payments are as follows:</h2>*/}
                        {/*<h4 className={"text-center"}>Turkiye is Bankasi</h4>*/}
                        {/*  <h4 className={"text-center"}>6812 0013172</h4>*/}

                    </div>
                </section>
            </div>
        );
    }
}

export default DashBoard;